package app.view

import app.CustomRouter
import app.Routes
import app.api.CompaniesApi
import app.api.ProjectVariablesApi
import app.api.StagesApi
import app.components.ModalStore
import app.components.buttonText
import app.components.sidebarNavigation
import app.components.warningModal
import app.model.ProjectVariable
import app.model.ProjectVariableValue
import app.plugin.Routing
import app.svg.close
import app.svg.delete
import app.svg.edit
import app.utils.findFirstAvailableScope
import app.utils.getScope
import app.utils.getScopeListForSelect
import dev.fritz2.core.*

fun RenderContext.projectVariablesView(
    projectVariablesApi: ProjectVariablesApi,
    companyApi: CompaniesApi,
    stagesApi: StagesApi,
    projectId: String?,
) {
    val editingProjectVariable = storeOf<ProjectVariable?>(null)
    val showCreateNew = storeOf(false)
    val newVariableName = storeOf("")
    val newVariableValue = storeOf("")
    val showModalStore = storeOf(ModalStore(show = false, message = ""))
    warningModal(modalStore = showModalStore)

    if (projectId == null) {
        CustomRouter.navTo(mapOf("route" to Routes.PROJECTS))
        return
    }

    companyApi.handler()
    companyApi.data.render { companies ->
        stagesApi.handler()
        stagesApi.data.render { stages ->
            projectVariablesApi.handler(projectId)
            projectVariablesApi.data.render { projectVariables ->
                div("flex gap-4 dark:text-white") {
                    sidebarNavigation(projectId)
                    div("basis-10/12 border rounded-md shadow-md my-4 p-4 dark:bg-gray-800 dark:border-gray-700") {
                        projectVariables.forEach { projectVariable ->
                            editingProjectVariable.data.render { editingPv ->
                                div("flex border rounded-md p-4 mb-4 items-center group dark:border-gray-700") {
                                    div("basis-4/12 mb-auto flex") {
                                        if (editingPv != null && editingPv.id == projectVariable.id) {
                                            input("w-36 border rounded p-1 dark:bg-gray-700 dark:border-gray-600 dark:text-white") {
                                                value(editingPv.name)
                                                changes.values() handledBy { newName ->
                                                    editingProjectVariable.update(
                                                        editingPv.copy(
                                                            name = newName
                                                        )
                                                    )
                                                }
                                            }
                                        } else {
                                            div("w-36 truncate") {
                                                +projectVariable.name
                                            }
                                            button("ml-1 group-hover:flex hidden dark:text-gray-200") {
                                                clicks handledBy {
                                                    editingProjectVariable.update(projectVariable)
                                                }
                                                title("Edit Project Variable")
                                                edit("size-4 m-auto")
                                            }
                                            button("ml-1 group-hover:flex hidden dark:text-gray-200") {
                                                clicks handledBy {
                                                    showModalStore.update(
                                                        ModalStore(
                                                            show = true,
                                                            message = "Are you sure you want to delete ${projectVariable.name}?",
                                                            onConfirm = {
                                                                projectVariablesApi.deleteProjectVariable(
                                                                    projectVariable.id
                                                                )
                                                            }
                                                        )
                                                    )
                                                }
                                                title("Delete Project Variable")
                                                delete("size-4 m-auto")
                                            }
                                        }
                                    }
                                    div("basis-8/12") {
                                        if (editingPv != null && editingPv.id == projectVariable.id) {
                                            div("flex flex-col gap-2") {
                                                editingPv.values.forEachIndexed { index, scope ->
                                                    div("flex justify-between items-center gap-4") {
                                                        input("border rounded p-1 w-60 dark:bg-gray-700 dark:border-gray-600 dark:text-white") {
                                                            value(scope.value)
                                                            changes.values() handledBy { newValue ->
                                                                editingProjectVariable.update(
                                                                    editingPv.copy(
                                                                        values = editingPv.values.mapIndexed { i, value ->
                                                                            if (i == index) value.copy(value = newValue) else value
                                                                        }
                                                                    )
                                                                )
                                                            }
                                                        }
                                                        if (scope.stageId == null && scope.companyId == null) {
                                                            div("rounded-3xl bg-gray-400 py px-2 ml-auto dark:bg-gray-600") {
                                                                +"default"
                                                            }
                                                        } else {
                                                            div("flex") {
                                                                select("w-52 p-2 border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white") {
                                                                    value("${scope.companyId}-${scope.stageId}")
                                                                    getScopeListForSelect(
                                                                        companies,
                                                                        stages,
                                                                        editingPv.values,
                                                                        scope
                                                                    ).forEach { option ->
                                                                        option {
                                                                            value("${option.value.companyId}-${option.value.stageId}")
                                                                            +option.label
                                                                            if (option.value.companyId == scope.companyId && option.value.stageId == scope.stageId) {
                                                                                selected(true)
                                                                            }
                                                                        }
                                                                    }
                                                                    changes.values() handledBy { newScope ->
                                                                        val (companyId, stageId) = newScope.split(
                                                                            "-"
                                                                        )
                                                                        editingProjectVariable.update(
                                                                            editingPv.copy(
                                                                                values = editingPv.values.mapIndexed { i, value ->
                                                                                    if (i == index) {
                                                                                        value.copy(
                                                                                            companyId = if (companyId == "null") null else companyId.toInt(),
                                                                                            stageId = if (stageId == "null") null else stageId.toInt()
                                                                                        )
                                                                                    } else value
                                                                                }
                                                                            )
                                                                        )
                                                                    }
                                                                }
                                                                button("my-auto p-1") {
                                                                    clicks handledBy {
                                                                        editingProjectVariable.update(
                                                                            editingPv.copy(
                                                                                values = editingPv.values.filterIndexed { i, _ -> i != index }
                                                                            )
                                                                        )
                                                                    }
                                                                    title("Remove Scope")
                                                                    close("size-6")
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                div("flex mt-2") {
                                                    val firstAvailableScope = findFirstAvailableScope(
                                                        companies = companies,
                                                        stages = stages,
                                                        currentValues = editingPv.values
                                                    )
                                                    buttonText(
                                                        text = "+",
                                                        isDisabled = firstAvailableScope == null,
                                                        onClick = {
                                                            firstAvailableScope?.let { newScope ->
                                                                editingProjectVariable.update(
                                                                    editingPv.copy(
                                                                        values = editingPv.values + newScope.copy(
                                                                            value = editingPv.values.first().value
                                                                        )
                                                                    )
                                                                )
                                                            }
                                                        }
                                                    )
                                                    div("ml-auto flex gap-2") {
                                                        button("px-4 py-2 bg-blue-500 text-white rounded dark:bg-gray-700 dark:text-white") {
                                                            close("size-6")
                                                            clicks handledBy {
                                                                editingProjectVariable.update(null)
                                                            }
                                                        }
                                                        buttonText(
                                                            text = "Save",
                                                            onClick = {
                                                                projectVariablesApi.updateProjectVariable(editingPv)
                                                                editingProjectVariable.update(null)
                                                            }
                                                        )
                                                    }
                                                }
                                            }
                                        } else {
                                            projectVariable.values
                                                .groupBy { it.value }
                                                .forEach { (value, scopes) ->
                                                    div("flex flex-col sm:flex-row p-1 gap-2") {
                                                        div("w-60 font-medium truncate") { +value }
                                                        div("flex-1 flex flex-wrap gap-2 justify-end") {
                                                            scopes.forEach { scope ->
                                                                div("rounded-3xl bg-gray-400 py px-2 dark:bg-gray-600") {
                                                                    +getScope(scope, companies, stages)
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                        }
                                    }
                                }
                            }
                        }
                        showCreateNew.data.render {
                            if (showCreateNew.current) {
                                div("border rounded-md p-4 mb-4 dark:border-gray-700") {
                                    div("flex flex-col gap-4") {
                                        input("border rounded p-1 dark:bg-gray-700 dark:border-gray-600 dark:text-white") {
                                            placeholder("Variable Name")
                                            value(newVariableName.data)
                                            changes.values() handledBy newVariableName.update
                                        }
                                        input("border rounded p-1 dark:bg-gray-700 dark:border-gray-600 dark:text-white") {
                                            placeholder("Default Value")
                                            value(newVariableValue.data)
                                            changes.values() handledBy newVariableValue.update
                                        }
                                        div("flex justify-end gap-2") {
                                            button("px-4 py-2 bg-gray-200 rounded dark:bg-gray-600") {
                                                +"Cancel"
                                                clicks handledBy {
                                                    showCreateNew.update(false)
                                                    newVariableName.update("")
                                                    newVariableValue.update("")
                                                }
                                            }
                                            buttonText(
                                                text = "Create",
                                                onClick = {
                                                    val newVariable = Routing.ProjectVariables.New.Body(
                                                        projectId = projectId.toInt(),
                                                        name = newVariableName.current,
                                                        values = listOf(
                                                            ProjectVariableValue(
                                                                companyId = null,
                                                                stageId = null,
                                                                value = newVariableValue.current
                                                            )
                                                        )
                                                    )
                                                    projectVariablesApi.postProjectVariable(newVariable)
                                                    showCreateNew.update(false)
                                                    newVariableName.update("")
                                                    newVariableValue.update("")
                                                }
                                            )
                                        }
                                    }
                                }
                            } else {
                                div("flex justify-end mb-4") {
                                    buttonText(
                                        text = "Create New Variable",
                                        onClick = { showCreateNew.update(true) }
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

